import { Divider, Flex, Heading, Text, View } from "@aws-amplify/ui-react";

export default function FAQPage() {
  return (
    <Flex
      direction="column"
      padding="32px 32px 32px 32px"
      backgroundColor="rgba(250,250,250,1)"
    >
      <Heading level={3} children="How Do I…" />
      <Divider size="small" />
      <Flex>
        <View>
          <Heading level={6} children="Add a Provider?" />
          <li>Go to Care Groups and click Health Providers</li>
        </View>
      </Flex>
      <Flex>
        <View>
          <Heading level={6} children="Add a Caregiver?" />
          <li>Go to Care Groups and click Caregivers</li>
        </View>
      </Flex>
      <Flex>
        <View>
          <Heading level={6} children="Add a Dependent?" />
          <li>Go to Care Groups and click Minor Dependents Or through the menu under your name</li>
        </View>
      </Flex>
      <Flex>
        <View>
          <Heading level={6} children="How do I add my Medical Records?" />
          <li>As of September 2024, the data provided by the largest EHRs is not complete or comparable, so users will need to add your providers, caregivers and recent health information by hand</li>
          <li><Text fontWeight={600} as="span">More information on this:</Text> In December 2023, the CURES act required Electronic Health Record systems (EHRs) like MyChart by Epic and others to send records to a centralized government’s record system managed by the Office of the National Coordinator for Health Information Technology (ONC).  This office then made available the FHIR API from which companies like Total Care Compass can source all of our user’s available electronic health records.  As of September 2024, the data provided by the largest EHRs is not complete or comparable and EHR systems have until Dec 2025 to provide standardized information for all patients at this time, PCM will bring in user’s EHR data and will provide a merge function for the data already in our system</li>
        </View>
      </Flex>
      <Flex>
        <View>
          <Heading level={6} children="How do I add Images or Videos?" />
          <li>Click on Health Records and click Imaging and Lab Results. Here you can upload images, videos, or scans</li>
        </View>
      </Flex>
      <Flex>
        <View>
          <Heading level={6} children="How do I add Care notes?" />
          <li>Click on Care Notes and then Add</li>
        </View>
      </Flex>
      <Flex>
        <View>
          <Heading level={6} children="How do I add an encounter?" />
          <li>Navigate to your provider and click add encounter</li>
        </View>
      </Flex>
      <Flex>
        <View>
          <Heading level={6} children="How do I add additional information to my fact sheet?" />
          <li>Click on “Update Fact sheet” and you can create custom sections that will be added to the fact sheet. This allows you to add any additional information they may be important</li>
        </View>
      </Flex>
      <Heading level={3} children="General Total Care Compass Questions" />
      <Divider size="small" />
      <Flex>
        <View>
          <Heading level={6} children="What type of Providers should I add?" />
          <li>Anyone who is giving you health advice, dentists, OT, PT, naturopaths, etc.</li>
        </View>
      </Flex>
      <Flex>
        <View>
          <Heading level={6} children="Can I connect to a patient portal to bring in past medical records?" />
          <li>Not at this time, but we are busy making sure we have this available in the very near future. Join our email list to make sure you get all the latest updates as we continue to grow</li>
          <li>More detailed information, in December 2023, the CURES act required Electronic Health Record systems (EHRs) like MyChart by Epic and others to send records to a centralized government’s record system managed by the Office of the National Coordinator for Health Information Technology (ONC).  This office then made available the FHIR API from which companies like Total Care Compass can source all of our user’s available electronic health records.  As of September 2024, the data provided by the largest EHRs is not complete or comparable and EHR systems have until Dec 2025 to provide standardized information for all patients at this time, PCM will bring in user’s EHR data and will provide a merge function for the data already in our system</li>
        </View>
      </Flex>
      <Flex>
        <View>
          <Heading level={6} children="What is Total Care Compass for?" />
          <li>Total Care Compass is here to help create a comprehensive medical file and ease the burden of caregiving. PCM offers cross caregiving functionality; this feature allows providers, caregivers, parents, and anyone else involved in the care of someone to be on the same page</li>
        </View>
      </Flex>
      <Flex>
        <View>
          <Heading level={6} children="Can I share this file with my providers?" />
          <li>You can add them as a caregiver or you can download the factsheet and email them a copy or bring it to your next appointment</li>
        </View>
      </Flex>
      <Flex>
        <View>
          <Heading level={6} children="Can I remove access from someone I share my file with?" />
          <li>Yes, go to Care Groups and click on caregivers. You will see a red “remove” button. Once you remove them they will no longer have access to the files</li>
        </View>
      </Flex>
      <Flex>
        <View>
          <Heading level={6} children="How is my data stored?" />
          <li>Your data is stored in HIPAA compliant servers</li>
        </View>
      </Flex>
    </Flex>
  );
}
